import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Notification } from '@shared/components/notification/notification';
import { LoadingService } from '@core/services/loading';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { LoadingBarModule } from '@ngx-loading-bar/core'; // ✅ استيراد الموديول
import { AuthService } from '@core/services/auth';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Notification, CommonModule, LoadingBarModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected title = 'hawkem';
  isLoading$!: Observable<boolean>;

  constructor(
    private loadingService: LoadingService,
    private auth: AuthService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.isLoading$ = this.loadingService.loading$;
  }
}
